import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { CartProvider } from './contexts/CartContext';
import { ToastProvider } from './contexts/ToastContext';

// Import CSS - colors first to define CSS variables
import './css/colors.css';
import './css/main.css';
import './css/nav.css';
import './css/footer.css';
import './css/trading.css';

// Pages - Will be created next
import Home from './components/pages/Home';
import About from './components/pages/About';
import Terms from './components/pages/Terms';
import PrivacyPolicy from './components/pages/PrivacyPolicy';
import DataDeletion from './components/pages/DataDeletion';
import Services from './components/pages/Services';
import Blog from './components/pages/Blog';
import BlogPost from './components/pages/BlogPost';
import CreateBlog from './components/pages/CreateBlog';
import EditBlog from './components/pages/EditBlog';
import AdminBlogReview from './components/pages/AdminBlogReview';
import CamelsGallery from './components/pages/CamelsGallery';
import WharfGallery from './components/pages/WharfGallery';
import AdminInspector from './components/pages/AdminInspector';
import AdminJobs from './components/pages/AdminJobs';
import AdminArchitecture from './components/pages/AdminArchitecture';
import AdminAnalytics from './components/pages/AdminAnalytics';
import AdminDatabase from './components/pages/AdminDatabase';
import AdminDMARC from './components/pages/AdminDMARC';
import DMCA from './components/pages/DMCA';
import Contact from './components/pages/Contact';
import FAQ from './components/pages/FAQ';
import Login from './components/pages/Login';
import Register from './components/pages/Register';
import Signin from './components/pages/Signin';
import CreateAccount from './components/pages/CreateAccount';
import RegistrationSuccess from './components/pages/RegistrationSuccess';
import VerifyEmail from './components/pages/VerifyEmail';
import VerifyAdditionalEmail from './components/pages/VerifyAdditionalEmail';
import ForgotPassword from './components/pages/ForgotPassword';
import ResetPassword from './components/pages/ResetPassword';
import Profile from './components/pages/Profile';
import MyBlogs from './components/pages/MyBlogs';
import MyServices from './components/pages/MyServices';
import Cart from './components/pages/Cart';
import BookCall from './components/pages/BookCall';
import TradingHub from './components/pages/trading/TradingHub';
import Positions from './components/pages/trading/Positions';
import Orders from './components/pages/trading/Orders';
import Apps from './components/pages/Apps';
import Authors from './components/pages/Authors';
import Messaging from './components/pages/Messaging';
import NotFound from './components/pages/NotFound';
import RecessionMonitor from './components/pages/RecessionMonitor';
import TrendArticle from './components/pages/TrendArticle';

// Common components
import Navigation from './components/common/Navigation';
import Footer from './components/common/Footer';
import Chatbot from './components/Chatbot';
import RouteSEO from './components/common/RouteSEO';

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <CartProvider>
          <Router>
            <RouteSEO />
            <div className="App">
              <Navigation />
              <main>
                <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/terms-of-service" element={<Terms />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/data-deletion" element={<DataDeletion />} />
                <Route path="/dmca" element={<DMCA />} />
                {/* <Route path="/services" element={<Services />} /> */}
                {/* <Route path="/blog" element={<Blog />} /> */}
                {/* <Route path="/blog/create" element={<CreateBlog />} /> */}
                {/* <Route path="/blog/edit/:slug" element={<EditBlog />} /> */}
                {/* <Route path="/blog/:slug" element={<BlogPost />} /> */}
                {/* <Route path="/admin/blog-review" element={<AdminBlogReview />} /> */}
                <Route path="/admin/database" element={<AdminDatabase />} />
                <Route path="/admin/dmarc" element={<AdminDMARC />} />
                <Route path="/admin/jobs" element={<AdminJobs />} />
                <Route path="/admin/architecture" element={<AdminArchitecture />} />
                <Route path="/admin/analytics" element={<AdminAnalytics />} />
                <Route path="/camels" element={<CamelsGallery />} />
                <Route path="/wharf"  element={<WharfGallery />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/login" element={<Login />} />
                <Route path="/signin" element={<Signin />} />
                <Route path="/register" element={<Register />} />
                <Route path="/create-account" element={<CreateAccount />} />
                <Route path="/registration-success" element={<RegistrationSuccess />} />
                <Route path="/verify-email/:token" element={<VerifyEmail />} />
                <Route path="/verify-additional-email" element={<VerifyAdditionalEmail />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password/:uid/:token" element={<ResetPassword />} />
                <Route path="/profile" element={<Profile />} />
                {/* <Route path="/my-blogs" element={<MyBlogs />} /> */}
                {/* <Route path="/my-services" element={<MyServices />} /> */}
                {/* <Route path="/cart" element={<Cart />} /> */}
                <Route path="/book-call" element={<BookCall />} />
                <Route path="/trading" element={<TradingHub />} />
                <Route path="/trading/dashboard" element={<TradingHub />} />
                <Route path="/trading/positions" element={<Positions />} />
                <Route path="/trading/orders" element={<Orders />} />
                <Route path="/apps" element={<Apps />} />
                <Route path="/authors" element={<Authors />} />
                <Route path="/messages" element={<Messaging />} />
                <Route path="/2026RecessionMonitoring" element={<RecessionMonitor />} />
                <Route path="/trends/:date/:hash" element={<TrendArticle />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </main>
            <Footer />
            <Chatbot />
          </div>
          </Router>
        </CartProvider>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;
